import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { PagedDataProvider } from '../../../../models/data-provider.model';
import { GlobalLoaderService } from '../../../../../core/providers/global-loader.service';
import { AbstractTableComponent } from '@shared/modules/tables/components/abstract-table.component';

@Component({
  selector: 'app-paged-table',
  templateUrl: './paged-table.component.html',
  styleUrls: ['../tables.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PagedTableComponent<P extends PagedDataProvider<D>, D> extends AbstractTableComponent<P, D> {

  constructor(protected cd: ChangeDetectorRef,
              protected globalLoader: GlobalLoaderService) {
    super(cd, globalLoader);
  }

}
